//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    utmSource() {
      return this.$route.query.utm_source;
    },
    utmCampaign() {
      return this.$route.query.utm_campaign;
    },
    utmMedium() {
      return this.$route.query.utm_medium;
    },
    url() {
      const utm = {
        utm_source: this.utmSource,
        utm_campaign: this.utmCampaign,
        utm_medium: this.utmMedium,
      };
      const params = [];
      Object.keys(utm).forEach((key) => {
        const val = utm[key];

        if (val) {
          params.push(`${key}=${val}`);
        }
      });

      if (params.length) {
        return `/plus?${params.join('&')}`;
      }

      return '/plus';
    },
  },
};
